import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';

import { RiFileTextLine } from '@remixicon/react';

import { ChatAttachment, attachmentKey } from '../../types';

const useStyles = makeStyles(theme => ({
  chip: {
    maxWidth: theme.spacing(30),
    height: 'var(--bui-space-6)',
    fontSize: 'var(--bui-font-size-2)',
    backgroundColor: 'var(--bui-bg-surface-2)',
    color: 'var(--bui-fg-primary)',
  },
  icon: {
    marginLeft: theme.spacing(0.75),
    flexShrink: 0,
  },
}));

interface AttachmentChipProps {
  attachment: ChatAttachment;
  onRemove?: (key: string) => void;
  onClick?: (attachment: ChatAttachment) => void;
}

export const AttachmentChip = ({
  attachment,
  onRemove,
  onClick,
}: AttachmentChipProps) => {
  const classes = useStyles();
  const handleClick = () => {
    if (onClick) {
      onClick(attachment);
      return;
    }
    if (attachment.uri) {
      window.open(attachment.uri, '_blank', 'noopener,noreferrer');
    }
  };
  return (
    <Chip
      className={classes.chip}
      size="small"
      label={attachment.title}
      icon={<RiFileTextLine size={14} className={classes.icon} />}
      onClick={attachment.uri || onClick ? handleClick : undefined}
      onDelete={
        onRemove ? () => onRemove(attachmentKey(attachment)) : undefined
      }
    />
  );
};
